import { TypographyOptions } from '@mui/material/styles/createTypography';

const primaryFontFamily = "'Barlow', sans-serif";
const primaryFontLineHeight = 1.2;

const secondaryFontFamily = "'Space Mono', monospace";
const secondaryFontLineHeight = 1.5;

enum FontWeight {
  light = 300,
  regular = 400,
  medium = 500,
  semibold = 600,
  bold = 700,
}

export const typography: TypographyOptions = {
  fontFamily: primaryFontFamily,
  htmlFontSize: 16,
  h1: {
    fontFamily: primaryFontFamily,
    fontSize: '4.5rem',
    fontWeight: FontWeight.semibold,
    lineHeight: primaryFontLineHeight,
  },
  h2: {
    fontFamily: primaryFontFamily,
    fontSize: '2.286rem',
    fontWeight: FontWeight.semibold,
    lineHeight: primaryFontLineHeight,
  },
  h3: {
    fontFamily: secondaryFontFamily,
    fontSize: '1.5rem',
    fontWeight: FontWeight.regular,
    lineHeight: secondaryFontLineHeight,
  },
  h4: {
    fontFamily: primaryFontFamily,
    fontSize: '1.5rem',
    fontWeight: FontWeight.semibold,
    lineHeight: primaryFontLineHeight,
  },
  h5: {
    fontFamily: secondaryFontFamily,
    fontSize: '1rem',
    fontWeight: FontWeight.regular,
    lineHeight: secondaryFontLineHeight,
  },
  h6: {
    fontFamily: secondaryFontFamily,
    fontSize: '0.875rem',
    fontWeight: FontWeight.bold,
    letterSpacing: '0.1rem',
    lineHeight: secondaryFontLineHeight,
    textTransform: 'uppercase',
  },
  subtitle1: {
    fontFamily: primaryFontFamily,
    fontSize: '1.125rem',
    fontWeight: FontWeight.semibold,
    lineHeight: primaryFontLineHeight,
  },
  subtitle2: {
    fontFamily: secondaryFontFamily,
    fontSize: '1.125rem',
    fontWeight: FontWeight.regular,
    lineHeight: secondaryFontLineHeight,
  },
  body1: {
    fontFamily: primaryFontFamily,
    fontSize: '1rem',
    fontWeight: FontWeight.medium,
    lineHeight: primaryFontLineHeight,
  },
  body2: {
    fontFamily: primaryFontFamily,
    fontSize: '0.875rem',
    fontWeight: FontWeight.medium,
    lineHeight: primaryFontLineHeight,
  },
  button: {
    fontFamily: primaryFontFamily,
    fontSize: '0.875rem',
    fontWeight: FontWeight.bold,
    letterSpacing: '0.1rem',
    lineHeight: 1.714,
    textTransform: 'uppercase',
  },
  caption: {
    fontFamily: primaryFontFamily,
    fontSize: '0.75rem',
    fontWeight: FontWeight.regular,
    lineHeight: primaryFontLineHeight,
  },
  overline: {
    fontFamily: secondaryFontFamily,
    fontSize: '0.875rem',
    fontWeight: FontWeight.regular,
    letterSpacing: '0.15rem',
    lineHeight: secondaryFontLineHeight,
    textTransform: 'uppercase',
  },
};
